export const IAM_API_ENDPOINT = 'https://iam-api.retailsvc.com';
